<script lang="ts">
  type Metric = {
    value: string;
    label: string;
    // When set, the label renders `labelPre` + a link on `linkText`.
    labelPre?: string;
    link?: string;
    linkText?: string;
  };

  const metrics: Metric[] = [
    {
      value: '75.2%',
      label: 'Detection Rate on EVMBench',
      labelPre: 'Detection Rate on ',
      link: '/evmbench',
      linkText: 'EVMBench'
    },
    { value: '~2.7%', label: 'Observed False Positive Rate' },
    { value: '~$100', label: 'Average user cost per EVMBench repo' }
  ];
</script>

<section class="evmbench-results">
  <div class="container">
    <div class="er-grid">
      {#each metrics as metric}
        <div class="er-stat">
          <span class="er-value">{metric.value}</span>
          <span class="er-label">
            {#if metric.link}
              {metric.labelPre}<a
                class="er-link"
                href={metric.link}>{metric.linkText}</a
              >
            {:else}
              {metric.label}
            {/if}
          </span>
        </div>
      {/each}
    </div>
  </div>
</section>

<style>
  .evmbench-results {
    /* Stat strip sitting directly above the benchmark chart. The proof-title
       above owns the top gap; this strip owns the gap down to the chart. */
    margin-bottom: clamp(40px, 6vw, 64px);
  }

  /* Capped to the chart's width and centred so the three numbers line up
     over the bars below. */
  .er-grid {
    max-width: 760px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: var(--gap);
  }

  .er-stat {
    text-align: center;
    padding: 0 8px;
  }

  .er-value {
    display: block;
    font-family: var(--font-display);
    font-size: clamp(2rem, 4.5vw, 3rem);
    font-weight: 800;
    letter-spacing: -0.03em;
    line-height: 1;
    margin-bottom: 14px;
    color: var(--accent);
  }
  .er-label {
    display: block;
    font-family: var(--font-mono);
    font-size: 0.75rem;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    line-height: 1.5;
    color: var(--fg-muted);
  }
  .er-link {
    color: inherit;
    text-decoration: underline;
    text-underline-offset: 2px;
    text-decoration-thickness: 1px;
  }
  .er-link:hover {
    color: var(--accent);
  }

  @media (max-width: 768px) {
    .er-grid {
      grid-template-columns: 1fr;
      gap: 28px;
    }
  }
</style>
